declare namespace $ {

	type $bog_card_header__title_bog_card_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_header['title'] >
	>
	type $bog_card_header__subtitle_bog_card_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_header['subtitle'] >
	>
	type $bog_card_tag__text_bog_card_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_tag['text'] >
	>
	type $bog_card_tag__text_bog_card_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_tag['text'] >
	>
	type $bog_card_tag__text_bog_card_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_tag['text'] >
	>
	type $bog_card_tag__text_bog_card_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_tag['text'] >
	>
	type $bog_card_tag__text_bog_card_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_tag['text'] >
	>
	type $mol_view__sub_bog_card_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_card_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $bog_card_contact__uri_bog_card_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['uri'] >
	>
	type $bog_card_contact__name_bog_card_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['name'] >
	>
	type $bog_card_contact__username_bog_card_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['username'] >
	>
	type $bog_card_contact__uri_bog_card_13 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['uri'] >
	>
	type $bog_card_contact__name_bog_card_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['name'] >
	>
	type $bog_card_contact__username_bog_card_15 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_contact['username'] >
	>
	type $mol_list__rows_bog_card_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_card_footer__start_bog_card_17 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_footer['start'] >
	>
	type $bog_card_footer__center_bog_card_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_footer['center'] >
	>
	type $bog_card_footer__end_bog_card_19 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_card_footer['end'] >
	>
	type $mol_view__sub_bog_card_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_card extends $mol_page {
		Theme( ): $bog_theme_auto
		Particles( ): $bog_card_particles
		Header( ): $bog_card_header
		Service_tag1( ): $bog_card_tag
		Service_tag2( ): $bog_card_tag
		Service_tag3( ): $bog_card_tag
		Service_tag4( ): $bog_card_tag
		Service_tag5( ): $bog_card_tag
		Services( ): $mol_view
		Divider( ): $mol_view
		Contacts_title( ): $mol_text
		Contact_erik( ): $bog_card_contact
		Contact_kirill( ): $bog_card_contact
		Contacts( ): $mol_list
		Footer( ): $bog_card_footer
		Card( ): $mol_view
		title( ): string
		plugins( ): readonly(any)[]
		minimal_width( ): number
		minimal_height( ): number
		Head( ): any
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map